import RequestService from './request-service';

/**
 * Get betbuilder details for rebet from mybets tab
 */
export default class BetBuilderMybetDetailsService extends RequestService {
  /**
   * @param {number} betSlipGroupId 
   */
  constructor(betSlipGroupId) {
    super();

    this.endpoint = this.$config.endpoints.betBuilderHistoryDetails;

    /**
     * Request method
     * @type {string}
     */
    this.method = 'get';

    /**
     * Add headers
     */
    const { authorizationHeaders } = this.$config;
    this.headers = authorizationHeaders;
    this.addHeader('ExternalUserID', APP_SETTINGS.player.id);

    /**
     * Set get params
     */
    this.getParams = {
      BetSlipGroupID: betSlipGroupId, // Betslip ID
    }
  }
}